module.exports = __webpack_public_path__ + "static/media/close-x.edeef416.png";